import router from '@/pages/user/router'
import routerLanding from '@/pages/index/router'

import api from '@/services/index.js'
import { getPrefix } from '@/services/modules/global.js'
const configV = require('../../config')

export const actions = {
  async userSignIn({ commit }, payload) {
    try {
      commit('setLoading', true)
      await api
        .post('/auth-service/v1/login', {
          phoneNumber: payload.phoneNumber,
          Password: payload.password,
        })
        .then((v) => {
          if (v.success == true) {
            commit('setError', null)
            commit('setAuth', true)
            commit('setAccessToken', v.authToken)
            commit('setUser', v.data)
            window.location.href = configV.RoutUser
            // router.push('/profile')
          } else {
            commit('setAuth', false)
            commit('setError', v.message)
          }
        })
        .catch((e) => {
          commit('setAuth', false)
          commit('setError', e.message)
        })
    } catch (e) {
      commit('setError', e.message)
    } finally {
      commit('setLoading', false)
    }
  },
  async userSignUp({ commit }, payload) {
    try {
      commit('setLoading', true)
      await api
        .post(
          '/auth-service/v1/signup',
          {
            phoneNumber: payload.phoneNumber,
            Password: payload.Password,
            Confirm_Password: payload.Confirm_Password,
            BankAccount: payload.BankAccount,
            BankCode: payload.BankCode,
            firstName: payload.firstName,
            lastName: payload.lastName,
            affiliateKey: payload.affiliateKey,
            isBonus: payload.isBonus,
            WalletId: payload.WalletId,
          },
          {
            headers: {
              tokenBank: payload.tokenBank,
            },
          }
        )
        .then((v) => {
          if (v.success == true) {
            routerLanding.push('/login')
          } else {
            commit('setError', v.message)
          }
        })
        .catch((e) => {
          commit('setError', e.message)
        })
    } catch (error) {
      commit('setError', error.message)
    } finally {
      commit('setLoading', false)
    }
  },
  async userSignOut({ commit }) {
    commit('setAuth', false)
    commit('setAccessToken', null)
    commit('setUser', null)
    commit('setError', null)
    window.location.href = '/'
  },
  async checkAuthIndex({ commit }) {
    try {
      await getPrefix((res) => {
        if (res.status) {
          commit('setLineId', res.data.LineId)

          localStorage.setItem('Prefix', JSON.stringify(res.data))
          // this.ImageCasino =
          //   this.Partner != 'Betflik' ? ImageCasino : ImageCasinoBetflik
          // this.ImagePOKER =
          //   this.Partner != 'Betflik' ? ImagePOKER : ImagePOKERBetflik
          // this.ImageTRADING =
          //   this.Partner != 'Betflik' ? ImageTRADING : ImageTRADINGBetflik
          // this.ImageSlot =
          //   this.Partner != 'Betflik' ? ImageSlot : ImageSlotBetflik
        } else {
        }
      })

      console.log('checkAuthIndex')
      commit('setLoading', true)
      const AccessToken = localStorage.getItem('AccessToken')
      if (AccessToken != null && AccessToken != 'null') {
        await api
          .get('/auth-service/v1/refresh')
          .then((v) => {
            if (v.success == false) {
              commit('setUser', v.data)
              if (routerLanding.history.current.name != 'Home') {
                commit('setError', null)
                localStorage.setItem('AccessToken', null)
                if (routerLanding.history.current.name == 'Index') {
                  // window.location.href = '/'
                }
                // routerLanfing.push('/').catch(() => {})

                // if (routerLanding.history.current.name == 'Login' || routerLanding.history.current.name == 'Signup') {
                // } else {
              }
            } else {
              commit('setError', null)
              console.log(router.history.current.name)
              if (routerLanding.history.current.name == 'Home') {
                window.location.href = configV.RoutUser
                // router.push('/profile').catch(() => {})
              } else if (routerLanding.history.current.name == 'Index') {
                window.location.href = configV.RoutUser

                // window.location.href = '/'
              }
            }
          })
          .catch(() => {
            if (
              routerLanding.history.current.name != 'Home' &&
              routerLanding.history.current.name != 'Login' &&
              routerLanding.history.current.name != 'Signup' &&
              routerLanding.history.current.name != 'Promotion'
            ) {
              commit('setAuth', false)
              commit('setError', null)
              localStorage.setItem('AccessToken', null)
              routerLanding.push('/').catch(() => {})
            }
          })
      } else {
        if (routerLanding.history.current.name == 'Home') {
          commit('setAuth', false)
          commit('setError', null)
          localStorage.setItem('AccessToken', null)
          // routerLanfing.push('/').catch(() => {})
          window.location.href = '/'
        } else {
        }
      }
      return true
    } catch (err) {
      commit('setError', null)
      localStorage.setItem('AccessToken', null)
      await routerLanding.push('/').catch(() => {})
      return err.response.data
    } finally {
      commit('setLoading', false)
    }
  },

  async checkAuth({ commit }) {
    try {
      await getPrefix((res) => {
        if (res.status) {
          commit('setLineId', res.data.LineId)
          localStorage.setItem('Prefix', JSON.stringify(res.data))
          // this.ImageCasino =
          //   this.Partner != 'Betflik' ? ImageCasino : ImageCasinoBetflik
          // this.ImagePOKER =
          //   this.Partner != 'Betflik' ? ImagePOKER : ImagePOKERBetflik
          // this.ImageTRADING =
          //   this.Partner != 'Betflik' ? ImageTRADING : ImageTRADINGBetflik
          // this.ImageSlot =
          //   this.Partner != 'Betflik' ? ImageSlot : ImageSlotBetflik
        } else {
        }
      })

      const AccessToken = localStorage.getItem('AccessToken')
      if (AccessToken != null && AccessToken != 'null') {
        await api
          .get('/auth-service/v1/refresh')
          .then((v) => {
            if (v.success == false) {
              commit('setError', null)
              localStorage.setItem('AccessToken', null)
              window.location.href = '/'
            } else {
              console.log('setUser AccessToken')
              commit('setUser', v.data)
              if (router.history.current.name != 'Home') {
                // router.push('/home').catch(() => {})
              }
            }
          })
          .catch(() => {
            commit('setAuth', false)
            commit('setError', null)
            localStorage.setItem('AccessToken', null)
            window.location.href = '/'
          })
      } else {
        commit('setAuth', false)
        commit('setError', null)
        localStorage.setItem('AccessToken', null)
        window.location.href = '/'
      }
      return true
    } catch (err) {
      commit('setError', null)
      localStorage.setItem('AccessToken', null)
      window.location.href = '/'
      return err.response.data
    } finally {
      commit('setLoading', false)
    }
  },
  setAccessToken({ commit }, payload) {
    commit('setAccessToken', payload)
  },
  setError({ commit }, payload) {
    commit('setError', payload)
  },
  setLoading({ commit }, payload) {
    commit('setLoading', payload)
  },

  setGameList({ commit }, payload) {
    commit('setGameList', payload)
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/actions.js